<template>
  <div v-if="isOpen" class="modal fade show d-block" tabindex="-1" style="background: rgba(0, 0, 0, 0.5); z-index: 100000;" @click.self="closeModal">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content p-5 animate__animated animate__fadeInUp">
        <div class="modal-header border-0">
          <h3 class="modal-title">Selectează firma</h3>
          <button type="button" class="btn btn-sm btn-icon btn-active-light-primary" @click="closeModal">
            <i class="ki-duotone ki-cross fs-1"></i>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="firmaSelectata" class="mb-5 p-4 border rounded bg-light">
            <h4>Detalii firmă selectată</h4>
            <div v-if="firmaSelectataObj">
              <p><strong>Denumire:</strong> {{ firmaSelectataObj.denumire }}</p>
              <p><strong>CUI:</strong> {{ firmaSelectataObj.cui }}</p>
              <p><strong>Reg. Com:</strong> {{ firmaSelectataObj.reg_com }}</p>
              <p><strong>Adresa:</strong> {{ firmaSelectataObj.adresa }}</p>
              <p>
                <strong>Stare firmă:</strong>
                <span
                  class="badge"
                  :class="getStareFirmaBadge(firmaSelectataObj.stare_firma).class"
                >
                  {{ getStareFirmaBadge(firmaSelectataObj.stare_firma).text }}
                </span>
              </p>
              <p>
                <strong>Activ:</strong>
                <span :class="['badge', firmaSelectataObj.activ === 1 ? 'badge-success' : 'badge-danger']">
                  {{ firmaSelectataObj.activ === 1 ? 'Activă' : 'Inactivă' }}
                </span>
              </p>
            </div>
          </div>
          <div class="row" data-kt-buttons="true">
            <div class="col-md-4 mb-5" v-for="firma in firmeDisponibile" :key="firma.id">
              <div class="position-relative">
                <div v-if="firma.autologin_firma" class="position-absolute top-0 end-0">
                  <span class="ribbon-right bg-danger text-white">Auto Login</span>
                </div>
                <label
                  class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 h-100"
                  :class="{ active: firmaSelectata === firma.id }">
                  <div class="d-flex align-items-center me-2">
                    <div class="form-check form-check-custom form-check-solid form-check-primary me-6">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="firma_selectata"
                        :value="firma.id"
                        v-model="firmaSelectata"
                      />
                    </div>
                    <div class="flex-grow-1">
                      <h2 class="d-flex align-items-center fs-5 fw-bold flex-wrap">
                        {{ firma.denumire }}
                      </h2>
                      <div class="mb-2">
                        <span
                          class="badge"
                          :class="roluriFirma[firma.rol]?.class || 'badge-secondary'"
                        >
                          Rol: {{ roluriFirma[firma.rol]?.text || 'Necunoscut' }}
                        </span>
                      </div>
                      <div class="fw-semibold opacity-50">
                        CUI: {{ firma.cui }}
                      </div>
                      <div class="fw-semibold opacity-50">
                        <span class="me-2">
                          <i class="fas fa-check-circle text-success" v-if="firma.activ === 1"></i>
                          <i class="fas fa-times-circle text-danger" v-else></i>
                          {{ firma.activ === 1 ? 'Activă' : 'Inactivă' }}
                        </span>
                        <span class="ms-2">
                          <span
                            class="badge"
                            :class="getStareFirmaBadge(firma.stare_firma).class"
                          >
                            {{ getStareFirmaBadge(firma.stare_firma).text }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button class="btn btn-light" @click="closeModal">Închide</button>
          <button class="btn btn-primary" :disabled="!firmaSelectata" @click="confirmaSchimbareFirma">Schimbă</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { getStareFirmaBadge } from '../../consts/firmaStatus';
import { useUserStore } from '../../stores/user';

export default {
  name: 'ModalSchimbaFirme',
  props: {
    uid: {
      type: [String, Number],
      default: null
    },
    afiseaza: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  data() {
    return {
      isOpen: this.afiseaza,
      firmeDisponibile: [],
      firmaSelectata: null,
      firmaSelectataObj: null,
      roluriFirma: {
        1: { text: 'Vizualizare', class: 'badge-success' },
        2: { text: 'Operator', class: 'badge-primary' },
        3: { text: 'Editare', class: 'badge-info' },
        4: { text: 'Administrare', class: 'badge-warning' },
        5: { text: 'Detinator', class: 'badge-danger' },
      }
    };
  },
  computed: {
    effectiveUid() {
      return this.uid || this.userStore.user?.id || window.initialUserData?.id || null;
    }
  },
  mounted() {
    window.addEventListener('open-modal-schimba-firme', this.onOpenEvent);
  },
  beforeUnmount() {
    window.removeEventListener('open-modal-schimba-firme', this.onOpenEvent);
  },
  created() {
    if (this.isOpen || this.afiseaza) {
      this.incarcaFirmeUtilizator(this.effectiveUid);
    }
  },
  watch: {
    afiseaza(newVal) {
      this.isOpen = newVal;
    },
    isOpen(newVal) {
      if (newVal) {
        this.incarcaFirmeUtilizator(this.effectiveUid);
      }
    },
    firmaSelectata(newVal) {
      if (newVal) {
        this.firmaSelectataObj = this.firmeDisponibile.find(f => f.id === newVal);
      } else {
        this.firmaSelectataObj = null;
      }
    }
  },
  methods: {
    getStareFirmaBadge, // expose imported method
    onOpenEvent() {
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
      this.$emit('inchide');
    },
    async incarcaFirmeUtilizator(uid) {
      const targetUid = uid || this.effectiveUid;
      if (!targetUid) return;
      try {
        const response = await axios.get(`/api/cont/firme-utilizator/${targetUid}`);
        this.firmeDisponibile = response.data.firme;
        const curenta = response.data.firma_curenta;
        if (curenta) {
          this.firmaSelectata = curenta;
        }
      } catch (error) {
        console.error('Eroare la încărcarea firmelor:', error);
      }
    },
    confirmaSchimbareFirma() {
      if (!this.firmaSelectata) return;
      axios.post('/api/cont/schimba-firma', {
        firma_id: this.firmaSelectata
      }).then(() => {
        window.location.reload();
      }).catch(error => {
        console.error('Eroare la schimbarea firmei:', error);
      });
    }
  }
};
</script>

<style scoped>
.ribbon-right {
  top: 10px;
  right: 10px;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.2rem 1.2rem;
  z-index: 10;
  background-color: #dc3545;
  color: white;
  border-radius: 0.2rem;
}
</style>